export const CALENDLY_URL = "https://calendly.com/perfectdigitals/30min";
export const PODCAST_URL = "https://www.youtube.com/@PerfectDigitals";
export const CONTACT_EMAIL = "connect@perfectdigitals.co.uk";

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "SEO",
    id: "seo",
    intro: "Build visibility where your customers are already searching.",
    items: [
      { label: "SEO Services", to: "/seo-services", desc: "SEO strategies designed around commercial outcomes." },
      { label: "Technical SEO", to: "/technical-seo", desc: "Crawlability, indexing, architecture and performance." },
      { label: "Local SEO", to: "/local-seo", desc: "Google Search, Google Maps and location-based searches." },
      { label: "Ecommerce SEO", to: "/ecommerce-seo", desc: "Organic visibility for products and categories." },
      { label: "B2B SEO", to: "/b2b-seo", desc: "Reach decision-makers researching solutions." },
      { label: "International SEO", to: "/international-seo", desc: "Search visibility across countries and markets." },
    ],
  },
  {
    label: "AI Search",
    id: "ai",
    intro: "Get discovered and recommended by AI.",
    items: [
      { label: "AI Search Visibility", to: "/ai-search-visibility", desc: "How your business appears across AI-powered search." },
      { label: "Answer Engine Optimisation (AEO)", to: "/aeo", desc: "Content answer-driven systems can interpret and use." },
      { label: "Generative Engine Optimisation (GEO)", to: "/geo", desc: "Visibility across generative AI recommendations." },
    ],
  },
  { label: "Results", to: "/results" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Podcast", href: PODCAST_URL, external: true },
  { label: "Perfect Digitals Studio", short: "Studio", to: "/studio" },
];

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
